import { reactive } from '@/lib/vue-composition-api.js';

function createCategoriesTree(allCategories, currentCategories, filterCategoryTitle = '') {
    const allCategoriesMap = {};
    const currentCategoriesSet = new Set();
    const lowerFilterCategoryTitle = filterCategoryTitle.toLowerCase();

    const newCurrentCategories = [];
    const result = [];

    currentCategories.forEach((category) => {
        currentCategoriesSet.add(category.id);
        newCurrentCategories.push(category);
    });

    allCategories.forEach((category) => {
        const hidden = filterCategoryTitle ?
            !category.title.toLowerCase().includes(lowerFilterCategoryTitle) :
            false;

        allCategoriesMap[category.id] = reactive({
            ...category,
            child: [],
            hasVisibleChild: false,
            hidden,
        });
    });

    for (let i = 0; i < newCurrentCategories.length; ++i) {
        const currentItem = allCategoriesMap[newCurrentCategories[i].id];

        if (currentItem?.parentId) {
            const parent = allCategoriesMap[currentItem.parentId];
            const hasParentInCurrentCategories = currentCategoriesSet.has(parent.id);

            if (!currentItem.hidden) {
                parent.hidden = false;
                parent.hasVisibleChild = true;
            }

            parent.child.push(currentItem);
            currentItem.parent = parent;

            if (!hasParentInCurrentCategories) {
                newCurrentCategories.push(parent);
                currentCategoriesSet.add(parent.id);
            }
        } else if (currentItem) {
            result.push(currentItem);
        }
    }

    return result;
}

export default function useFilterCategoriesTree(allCategories, currentCategories, activeOptions) {
    return createCategoriesTree(allCategories, currentCategories, activeOptions);
}
